import toast from "react-hot-toast";

export const SANotification = ({ type, message, icon, iconColor, duration, position }) => {
    toast[type === "info" ? "success" : type](message, {
        duration: type && type === 'loading' ? 4000 : duration,
        position: position,
        icon: type === "info" ? <i className="fa-solid fa-circle-info font18 text-primary"></i> : icon,
        iconTheme: {
            primary: iconColor
        }
    })
}